import React from "react";
import RootLayout from "../pages/RootLayout";
import ErrorPage from "../pages/Error";
import Dashboard from "../pages/Dashboard";
import DomainAdd from "../pages/domain/DomainAdd";
import DomainView from "../pages/domain/DomainView";
import DomainDetail from "../pages/domain/DomainDetail";
import DomainEdit from "../pages/domain/DomainEdit";
import Login from "../pages/Login";
import ProtectedRoute from "../components/ProtectedRoute";


export const routes = [
    {
        path: "/login",
        element: <Login/>,
    },
    {
        path: "/",
        element: (
            <ProtectedRoute>
                <RootLayout/>
            </ProtectedRoute>
        ),
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                element: <Dashboard/>
            },
            {
                path: 'domain',
                children: [
                    {index: true, element: <DomainView/>},
                    {path: 'add', element: <DomainAdd/>},
                    {
                        path: ':domainId',
                        children: [
                            {index: true, element: <DomainDetail/>},
                            {path: 'edit', element: <DomainEdit/>},
                        ]
                    }
                ],
            },
        ]
    }
];
